<template>
<div id="passenger-information-templates">
   
  <div v-if="!selectedTemplate">
    <div v-for="model in templates" :key="model.id" class='traffic-model-selection link' :class="'traffic-model-' + model.id" @click="selectTemplate(model.id)">
        <div class='name'>{{ model.name }}</div>
        <div class='description'>{{ model.description }}</div>
    </div>
  </div>

  <div v-else>
    <div v-if="selectedTemplate.id > 0">
      <div class='traffic-model-selection' :class="'traffic-model-' + selectedTemplate.id">
        <div class='name'>{{ selectedTemplate.name }}</div>
        <div class='description'>{{ selectedTemplate.description }}</div>
      </div>

      <div v-for="variant in selectedTemplate.variants" :key="variant.id" class='traffic-model-selection variant link' :class="'traffic-model-' + selectedTemplate.id" @click="selectTemplateVariant(variant)">
          <div class='name'>{{ variant.id }}. {{ variant.name }}</div>
      </div>
    </div>

  </div>

 

  

</div>
</template>

<script>

export default ({
    data: function() {
        return {
            selectedTemplate: null,
            templates: [
                
                { id: 0, name: "Vapaa teksti",  
                  description: "Vapaa teksti",
                  fi: "",
                  se: "",
                  en: "" 
                },
                { id: 1, 
                  name: "Totaalikatko", 
                  description: "Metroa ei voida liikennöidä millään osuudella", 
                  variants: [ 
                    { id: 1, 
                      name: "Metroliikenteen keskeyttäminen kokonaan",
                      fi: "Metroliikenne on keskeytetty toistaiseksi kokonaan. Älkää nousko juniin. Katsokaa lisätietoa hsl.fi",
                      se: "Det är tillsvidare stopp i metrotrafiken. Stig inte på tåget. För tilläggsinformation se HSL.fi.",
                      en: "Metro services are suspended until further notice. Do not board the trains. For more information, see HSL.fi." 
                     },
                    { id: 2, 
                      name: "Metroliikennettä ei aloiteta", 
                      fi: "Metroliikenne on keskeytetty toistaiseksi kokonaan. Älkää nousko juniin. Katsokaa lisätietoa hsl.fi",
                      se: "Det är tillsvidare stopp i metrotrafiken. Stig inte på tåget. För tilläggsinformation se HSL.fi.",
                      en: "Metro services are suspended until further notice. Do not board the trains. For more information, see HSL.fi." 
                    }
                ]},
                
                { id: 2, 
                  name: "Harvennettu liikenne", 
                  description: "Esimerkiksi kuljettaja- tai kalustopula tai välityskykyyn vaikuttava pitkäkestoinen turvalaitevika", 
                  variants : [ 
                    { id: 1, 
                      name: "Runko-osuuden vuoroväli 3 minuuttia",
                      fi: "Metroa liikennöidään poikkeuksellisesti harvennetulla vuorovälillä. <SYY>.",
                      se: "Metron kör undantagsvis med glesare tidtabell. <ORSAK>.",
                      en: "The metro is operating a reduced service. <REASON>."
                    },
                    { id: 2, 
                      name: "Runko-osuuden vuoroväli 3,75 minuuttia" },

                    { id: 3, name: "Runko-osuuden vuoroväli 5 minuuttia" },
                    { id: 4, name: "Runko-osuuden vuoroväli 7,5 minuuttia" },
                    { id: 5, name: "Runko-osuuden vuoroväli 10 minuuttia" }
                ]},

                { id: 3, name: "YRA-liikenne", 
                  description: "Häiriökohde ohitettavissa normaalisti yksittäisellä YRA-toiminnolla", 
                  variants: [ 
                    { id: 1, 
                      name: "YRA-alue välillä KIL-TAP",
                      fi: "Välillä Kivenlahti - Tapiola metroa voidaan liikennöidä vain toista raidetta pitkin. Vuorovälit ovat epätasaiset. <SYY>.",
                      se: "På sträckan Stenvik - Hagalund kan metron köra endast på ett spår. Oregelbundna turer. <ORSAK>.",
                      en: "The metro is using only one track between Kivenlahti - Tapiola. The headways are irregular. <REASON>."
                    },
                    { id: 2, 
                      name: "YRA-alue välillä TAP-RL",
                      fi: "Välillä Tapiola - Ruoholahti metroa voidaan liikennöidä vain toista raidetta pitkin. Vuorovälit ovat epätasaiset. <SYY>.",
                      se: "På sträckan Hagalund - Gräsviken kan metron köra endast på ett spår. Oregelbundna turer. <ORSAK>.",
                      en: "The metro is using only one track between Tapiola - Ruoholahti. The headways are irregular. <REASON>."
                    },
                    { id: 3, 
                      name: "YRA-alue välillä RL-IK",
                      fi: "Välillä Ruoholahti - Itäkeskus metroa voidaan liikennöidä vain toista raidetta pitkin. Vuorovälit ovat epätasaiset. <SYY>.",
                      se: "På sträckan Gräsviken - Östra centrum kan metron köra endast på ett spår. Oregelbundna turer. <ORSAK>.",
                      en: "The metro is using only one track between Ruoholahti - Itäkeskus. The headways are irregular. <REASON>."
                    }, 
                    { id: 4, 
                      name: "YRA-alue välillä IK-VS/MM",
                      fi: "Välillä Itäkeskus - Vuosaari metroa voidaan liikennöidä vain toista raidetta pitkin. Vuorovälit ovat epätasaiset. <SYY>.",
                      se: "På sträckan Östra centrum - Nordsjö kan metron köra endast på ett spår. Oregelbundna turer. <ORSAK>.",
                      en: "The metro is using only one track between Itäkeskus - Vuosaari. The headways are irregular. <REASON>."
                    }
                ]},

                { id: 4, name: "Osittainen liikenne lännestä", 
                  description: "Molemmat raiteet pois käytöstä tai ylipitkä YRA runko-osuudella", 
                  variants: [ 
                    { id: 1, name: "YRA-alue välillä KIL-TAP" },
                ]},

                { id: 5, name: "Osittainen liikenne idästä", 
                  description: "Molemmat raiteet pois käytöstä tai ylipitkä YRA runko-osuudella", 
                  variants: [ 
                    { id: 1, name: "YRA-alue välillä KIL-TAP" },
                ]},

                { id: 6, name: "Muut häiriötapaukset", 
                  description: "Häiriö kääntöraiteella tai varikkoliittymässä", 
                  variants: [ 
                    { id: 1, 
                      name: "Kivenlahden kääntöraide pois käytöstä",
                      fi: "Seuraava juna Vuosaareen lähtee laiturilta <LAITURI>.",
                      se: "Nästa tåg till Nordsjö avgår från spår <LAITURI>.",  
                      en: "Next train to Vuosaari departs from track <LAITURI>." 
                    },
                    { id: 2, 
                      name: "Tapiolan kääntöraide pois käytöstä",
                      fi: "Linja M2 ei poikkeuksellisesti liikennöi välillä Tapiola Ruoholahti. Vuorovälit välillä Tapiola Ruoholahti ovat normaalia pidemmät. Lisätietoja hsl.fi.",
                      se: "Linje M2 trafikerar undantagsvis inte mellan Hagalund och Gräsviken. Metrotrafiken är glesare än normalt mellan Hagalund och Gräsviken . Mer information på hrt.fi.",
                      en: "Metro line M2 does not exceptionally operate between Tapiola and Ruoholahti. Service is reduced between Tapiola and Ruoholahti. More info on hsl.fi."
                    },
                    { id: 3, 
                      name: "Mellunmäen kääntöraide pois käytöstä", 
                      fi: "Seuraava juna Tapiolaan lähtee laiturilta <LAITURI>.",
                      se: "Nästa tåg till Hagalund avgår från spår <LAITURI>.",  
                      en: "Next train to Tapiola departs from track <LAITURI>." 
                      },
                    { id: 4, 
                      name: "Vuosaaren kääntöraide pois käytöstä",
                      fi: "Metroliikenteessä on häiriöitä. Seuraava juna Kivenlahteen/Tapiolaan lähtee laiturilta <LAITURI>.",
                      se: "Bästa passagerare. Det finns störningar i metrotrafiken. Nästa tåg till Stensvik/Hagalund avgår från spår <LAITURI>",
                      en: "Dear passengers. There are disruptions in the metro service. Next train to Kivenlahti/Tapiola departs from track <LAITURI>"
                    },
                ]},




            ]
        };
    },

    computed: {
        description() {
            //let selection = this.trafficModels.find(model => model.id == id);
            return "";
        }
    },

    methods: {
        selectTemplate(id){
            this.selectedTemplate = this.templates.find(model => model.id == id);
            if(!this.selectedTemplate.variants)
              this.$emit('select', this.selectedTemplate);
        },
        selectTemplateVariant(variant){       
           this.$emit('select',variant);
        }
    }
})
</script>


<style scoped >


</style>